import { DialogService } from "src/app/components/global/dialog/dialog.service";
import { ApplicationService } from "src/services/application.service";
import { HttpService } from "src/services/http.service";
import { SessionService } from "src/services/session.service";
import { ContentPart } from "../content-part";

export class ContentCaption extends ContentPart {
  public constructor(
    id: string,
    dialog: DialogService,
    application: ApplicationService,
    session: SessionService,
    http: HttpService,
    contentPostUrl: string,
  ) {
    super(id, "Caption", dialog, application, session, http, contentPostUrl);
  }
}
